import {DeliveryChecks} from './delivery-checks.model';

export class DeliveryChecksList {
	public static ACCESSORIES = 'accessories';
	public static DOCUMENTS = 'documents';
	public static SPECIAL_DOCUMENTS = 'specialdocuments';
	public static EQUIPMENT = 'equipment';
	public static VEHICLE = 'vehicle';
	public static FUEL_CARDS = 'fuelcards';

	ready: boolean;
	wasOpened = false;

	txt_category: string;

	visibleDeliveryChecks: DeliveryChecks[];
	invisibleDeliveryChecks: DeliveryChecks[];


	public static getMapCategories(): any {
		return [
			DeliveryChecksList.ACCESSORIES, DeliveryChecksList.DOCUMENTS,
			DeliveryChecksList.SPECIAL_DOCUMENTS, DeliveryChecksList.EQUIPMENT,
			DeliveryChecksList.VEHICLE, DeliveryChecksList.FUEL_CARDS
		];
	}

	constructor(txt_category: string) {
		this.txt_category = txt_category;
		this.visibleDeliveryChecks = [];
		this.invisibleDeliveryChecks = [];
	}

	addChecks(check: DeliveryChecks) {
		if (check.isCodOwnerASMP()) {
			this.invisibleDeliveryChecks.push(check);
		} else {
			this.visibleDeliveryChecks.push(check);
		}
		this.ready = this.isReady();
		check.update_status.subscribe(res => {
			this.ready = this.isReady();
			setTimeout(() => {
				this.wasOpened = !this.ready;
			}, 1000);
		});
	}

	checkItemsCount(): number {
		return this.visibleDeliveryChecks.length;
	}

	checkedItemsCount(): number {
		let result = 0;
		for (const item of this.visibleDeliveryChecks) {
			if (item.isItemReady()) {
				result++;
			}
		}
		return result;
	}

	public isReady(): boolean {
		for (let i = 0; i < this.visibleDeliveryChecks.length; i++) {
			if (!this.visibleDeliveryChecks[i].isItemReady()) {
				return false;
			}
		}
		return true;
	}
}
